import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import { ouvinteService, Utils } from '../../services';
import logoBoleto from '../../assets/boleto.png';
import logoCartao from '../../assets/cartao.png';
import logoPago from '../../assets/pago.png';
import { Load } from '../../components';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

const InformacoesPagamento = ({ ouvinte }) => {
    if (ouvinte.PAGO) {
        return (
            <img src={logoPago} alt="Logo Pago" />
        );
    } else if (ouvinte.NOSSONUMERO) {
        if (ouvinte.LINKBOLETO) {
            return (
                <a href={ouvinte.LINKBOLETO} target="_blank" rel="noopener noreferrer">
                    <img style={{ height: 48 }} src={logoBoleto} alt="Logo boleto" />
                    <br />
                    <span style={{ fontSize: 16 }}>Clique para gerar o boleto</span>
                </a>
            );
        }
        return (
            <div>
                <img style={{ height: 48 }} src={logoCartao} alt="Logo cartão" />
                <br />
                <span style={{ fontSize: 16 }}>Aguardando aprovação</span>
            </div>
        );
    }
    return (
        <span>Aguardando pagamento.</span>
    );
};

InformacoesPagamento.propTypes = {
    ouvinte: PropTypes.shape({
        PAGO: PropTypes.bool,
        NOSSONUMERO: PropTypes.string,
        LINKBOLETO: PropTypes.string,
    }).isRequired,
};

class InscricaoDetalhesOuvinte extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            carregando: true,
            nome: '',
            area: '',
            nomeEvento: '',
            ouvinte: {},
        };
    }

    async componentWillMount() {
        const codigoOuvinte = this.props.match.params.codigoOuvinte;
        if (codigoOuvinte) {
            const ouvinteInscricao = await ouvinteService.getOuvinte(codigoOuvinte);
            this.setState({
                carregando: false,
                nome: ouvinteInscricao.PESSOA,
                area: ouvinteInscricao.AREA,
                ouvinte: ouvinteInscricao,
                nomeEvento: `${ouvinteInscricao.EVENTO} - ${ouvinteInscricao.SUBEVENTO}`,
            });
        } else {
            this.setState({ carregando: false });
        }
    }

    async irParaPaginaInicial() {
        window.location.href = '/inscricao';
    }

    render() {
        const {
            carregando,
            nome,
            area,
            ouvinte,
            nomeEvento,
        } = this.state;
        const codigoOuvinte = this.props.match.params.codigoOuvinte;
        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Inscrição de ouvinte">
                <div>
                    {
                        carregando ?
                            <Load /> :
                            <div className="padding-content">
                                <GridList cols={3} cellHeight="auto">
                                    <GridTile cols={3} style={{ textAlign: 'center' }}>
                                        <h2>{nome}</h2>
                                        <h4>{nomeEvento}</h4>
                                    </GridTile>

                                    <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                        <h3>Pagamento</h3>
                                        {
                                            codigoOuvinte ?
                                                <InformacoesPagamento ouvinte={ouvinte} /> :
                                                <span>Aguardando finalização da inscrição.</span>
                                        }
                                    </GridTile>
                                    <GridTile cols={1.5} style={{ textAlign: 'center', padding: 8 }}>
                                        <h3>Área</h3>
                                        {area}
                                    </GridTile>
                                </GridList>
                            </div>
                    }
                </div>
            </MasterPage>
        );
    }
}

InscricaoDetalhesOuvinte.defaultProps = {
    codigoOuvinte: '',
};

InscricaoDetalhesOuvinte.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            codigoOuvinte: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(InscricaoDetalhesOuvinte);
